// extracted by mini-css-extract-plugin
export var addressFields = "_hg-0";
export var animationContainer = "_hg-1";
export var footer = "_hg-2";
export var lineItems = "_hg-3";
export var modalContent = "_hg-4";
export var orderName = "_hg-5";
export var strong = "_hg-6";
export var warning = "_hg-7";